<template>
  <div class="grey-box">
    <div class="center-box">
      <div class="icon-box">
        <i class="icon-gou1 iconfont"></i>
      </div>
      <div class="message">
        您已完成看样决策，<span>{{ scond + "秒" }}</span
        >后自动跳转
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      scond: 3,
    };
  },
  methods: {
    timeOut() {
      let that = this;
      setTimeout(function () {
        that.scond--;
        if (that.scond == 0) {
          that.$router.push(
            `/DecisionImg?proofId=${that.$route.query.proofId}&userId=${that.$route.query.userId}`
          );
        } else {
          that.timeOut();
        }
      }, 1000);
    },
  },
  mounted() {
    this.timeOut();
  },
};
</script>

<style lang='scss' scoped>
.grey-box {
  width: 100%;
  position: relative;
  height: calc(100vh - 88px);
  background: #f2f2f2;
  .center-box {
    padding-top: 30%;
    .icon-box {
      width: 120px;
      height: 120px;
      text-align: center;
      line-height: 120px;
      border-radius: 120px;
      margin: 0 auto;
      background: #3f996c;
      i {
        font-size: 60px;
        color: #fff;
      }
    }
    .message {
      text-align: center;
      margin-top: 42px;
      color: #606266;
      font-size: 28px;
      span {
        color: #3f996c;
      }
    }
  }
}
</style>